module.exports = __webpack_public_path__ + "img/car-theme.a0ddfec0.svg";